import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { ITransferAuthorityState } from "@/store/modules/transferAuthority/state";
import { TransferAuthorityMutations } from "@/store/modules/transferAuthority/mutations";

export enum TransferAuthorityActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_TRANSFER_AUTHORITY",
  CREATE = "CREATE_TRANSFER_AUTHORITY",
  CONFIRM = "CONFIRM_TRANSFER_AUTHORITY",
  CLOSE = "CLOSE_TRANSFER_AUTHORITY",
  DENY = "DENY_TRANSFER_AUTHORITY",
  FETCH_INBOX_SUMMARY = "FETCH_INBOX_SUMMARY_TRANSFER_AUTHORITY",
}

export const actions: ActionTree<ITransferAuthorityState, IRootState> = {
  async [TransferAuthorityActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    const result = await baseApi.get("/users/transfer-authority/get-authorities", {
      params: params,
    });
    commit(TransferAuthorityMutations.SET_LAZY_DATA, result.data.data);
    return result.data.data;
  },
  async [TransferAuthorityActions.CREATE]({ commit }, data) {
    const result = await baseApi.post("/users/transfer-authority/create", data);
    commit(TransferAuthorityMutations.SET_ONE, result.data);
    return result.data;
  },
  async [TransferAuthorityActions.CONFIRM]({ commit }, payload) {
    await baseApi.post("/users/transfer-authority/confirm", payload);
  },
  async [TransferAuthorityActions.CLOSE]({ commit }, payload) {
    await baseApi.post("/users/transfer-authority/close", payload);
  },
  async [TransferAuthorityActions.DENY]({ commit }, payload) {
    await baseApi.post("/users/transfer-authority/denied", payload);
  },
  async [TransferAuthorityActions.FETCH_INBOX_SUMMARY]() {
    try {
      const result = await baseApi.get(
        "/users/transfer-authority/inbox-summary"
      );
      return result.data.data;
    } catch (error) {
      // Fallback для старого/недоступного inbox-summary:
      // считаем входящие через существующий список полученных прав.
      const result = await baseApi.get(
        "/users/transfer-authority/get-authorities",
        { params: { page: 0, type: "IOUSER" } }
      );
      const items = result.data?.data?.items ?? [];
      const pendingCount = items.filter(
        (item: any) => item.status === "WAIT_CONFIRM"
      ).length;
      const activeCount = items.filter(
        (item: any) => item.status === "ACTIVE"
      ).length;
      return {
        pendingCount,
        activeCount,
        hasAny: pendingCount + activeCount > 0,
      };
    }
  },
};
